import React, { useState, useEffect, useMemo } from "react";
import css from "./index.m.css";
import { Input, Button, message } from "@cloud/atom-ui";
import classNames from "classnames";
import { queryString } from "@src/utils/common";
import { updateWhiteIp, getWhiteIp } from './thunk';
import useMappedState from "@src/utils/useMappedState";
import CommonHeader from "../../components/common-header";
import { getAppPathFromType } from "@src/utils/common";

const {TextArea} = Input;
export default props => {
  const {versionId = '', abilityType = ''} = useMappedState("root");
  const [ipDisabled, setIpDisabled] = useState(true);
  const [ipContent, setIpContent] = useState("");
  const [errorShow, setErrorShow] = useState(false);
  const {
    match: {
      params: {type: paramsType}
    }
  } = props;
  const appId = queryString("id") || "";
  let reg =
    /^(?:(?:[1/*][0-9][0-9]\.)|(?:1[0-9/*][0-9]\.)|(?:1[0-9][0-9/*]\.)|(?:[2/*][0-4][0-9]\.)|(?:2[0-4/*][0-9]\.)|(?:2[0-4][0-9/*]\.)|(?:25[0-5/*]\.)|(?:[1-9/*][0-9]\.)|(?:[1-9][0-9/*]\.)|(?:[0-9/*]\.)){3}(?:(?:[1/*][0-9][0-9])|(?:1[0-9/*][0-9])|(?:1[0-9][0-9/*])|(?:[2/*][0-4][0-9])|(?:2[0-4/*][0-9])|(?:2[0-4][0-9/*])|(?:25[0-5/*])|(?:[1-9/*][0-9])|(?:[1-9][0-9/*])|(?:[0-9/*]))$/;


  useEffect(() => {
    // 获取IP白名单
    getWhiteIp({appId: appId}, getAppPathFromType(paramsType)).then(res => {
      const {data, status} = res
      if (status == 1) {
        setIpContent(data.whiteIp)
      } else {
        message.warning(res?.errMsg || "获取IP白名单失败")
      }
    }).catch(error => {
      message.warning("获取IP白名单失败")
    })
  }, [])


  const save = () => {
    let ips = ipContent?.split(",") || '';
    let result = ips?.every?.((value) => {
      return reg.test(value);
    });
    if (ipContent && !result) {
      setErrorShow(true);
    } else {
      setErrorShow(false);
      updateWhiteIp({whiteIps: ipContent || '', appId: appId}, getAppPathFromType(paramsType)).then((res) => {
        if (res.status === 1) {
          setIpDisabled(true);
          message.success(res.errMsg || "设置成功")
        } else {
          message.warning(res.errMsg || "保存IP白名单失败")
        }
      }).catch(error => {
        message.warning(res.errMsg || "保存IP白名单失败")
      })

    }
  };

  const cancel = () => {
    setIpContent("");
    setErrorShow(false);
    setIpDisabled(true);
  };
  const update = () => {
    setIpDisabled(false);
  };
  const renderBtn = () => {
    if (ipDisabled) {
      return (
        <Button
          onClick={() => {
            update();
          }}
          type="primary"
          style={{width: 86}}
        >
          修改
        </Button>
      );
    } else {
      return (
        <>
          <Button
            onClick={() => {
              save();
            }}
            type="primary"
            style={{marginRight: 10, width: 86}}
          >
            保存
          </Button>
          <Button
            onClick={() => {
              cancel();
            }}
            style={{width: 86}}
          >
            取消
          </Button>
        </>
      );
    }
  };

  return (
    <div>
      <CommonHeader title="安全设置" headerStyle={{marginBottom: "19px"}} />
      <div className={css["ip-trust-list"]}>
        <div className={css["ip-trust-text"]}>IP白名单</div>
        <div>
          <TextArea
            showCount
            maxLength={300}
            className={classNames(css["textarea-box"], {
              [css["textarea-box-tip"]]: errorShow,
            })}
            disabled={ipDisabled}
            placeholder={"例如：192.168.20.1"}
            value={ipContent}
            onChange={(evt) => setIpContent(evt.target.value)}
          />
          <p
            className={css["ip-tip"]}
            style={{marginBottom: !errorShow ? 40 : 0, marginTop: 5}}
          >
            仅IP地址正确的服务器可调用接口，以英文符号( ,
            )分割；如：企业内部网段，请务必确认是公司出口IP；不配置则无限制
          </p>
          {errorShow && (
            <p
              className={css["ip-tip"]}
              style={{color: "red", marginBottom: errorShow ? 40 : 0}}
            >
              请输入正确的IP地址
            </p>
          )}
          {renderBtn()}
        </div>
      </div>
    </div>
  );
};
